// extracted by mini-css-extract-plugin
module.exports = {"main":"dashboard_main__1ehAN","navbar":"dashboard_navbar__31wPX","navbarItem":"dashboard_navbarItem__1lp1z"};